import { render } from "./CallButton.vue?vue&type=template&id=6850538a&scoped=true"
import script from "./CallButton.vue?vue&type=script&lang=js"
export * from "./CallButton.vue?vue&type=script&lang=js"

import "./CallButton.vue?vue&type=style&index=0&id=6850538a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6850538a"]])

export default __exports__